import { IBarcode } from '@app/models/barcode.interface';
import { IPicklist } from '@app/models/picklist.interface';
import { createAction, props } from '@ngrx/store';

export const loadPicklists = createAction(
  '[Picklists] Load Picklists',
  props<any>()
);

export const loadPicklistsSuccess = createAction(
  '[Picklists] Load Picklists Success',
  props<{ picklists: IPicklist[], total: number }>()
);

export const loadPicklistsFailure = createAction(
  '[Picklists] Load Picklists Failure',
  props<{ error: any }>()
);

export const filterByCategory = createAction(
  '[Picklists] Filter Picklists By Category',
  props<{ prdCatID: number, active: string, direction: string }>()
);

export const filterByCategorySuccess = createAction(
  '[Picklists] Filter Picklists By Category Success',
  props<any>()
);

export const filterByCategoryFailure = createAction(
  '[Picklists] Filter Picklists By Category Failure',
  props<{ error: any }>()
);

export const savePicklist = createAction(
  '[Picklists] Save Picklist',
  props<{ form: any }>()
);

export const savePicklistSuccess = createAction(
  '[Picklists] Save Picklist Success',
  props<any>()
);

export const savePicklistFailure = createAction(
  '[Picklists] Save Picklist Failure',
  props<{ error: any }>()
);

export const updatePicklist = createAction(
  '[Picklists] Update Picklist',
  props<{ form: any }>()
);

export const updatePicklistSuccess = createAction(
  '[Picklists] Update Picklist Success',
  props<{ picklist: any }>()
);

export const updatePicklistFailure = createAction(
  '[Picklists] Update Picklist Failure',
  props<{ error: any }>()
);

export const loadPicklist = createAction(
  '[Picklists] Load Picklist',
  props<{ pickListID: any }>()
);

export const loadPicklistSuccess = createAction(
  '[Picklists] Load Picklist Success',
  props<{ picklist: any }>()
);

export const loadPicklistFailure = createAction(
  '[Picklists] Load Picklist Failure',
  props<{ error: any }>()
);

export const filterByArea = createAction(
  '[Picklists] Filter Picklists By Area',
  props<{ prdAreaID: number, active: string, direction: string }>()
);

export const filterByAreaSuccess = createAction(
  '[Picklists] Filter Picklists By Area Success',
  props<any>()
);

export const filterByAreaFailure = createAction(
  '[Picklists] Filter Picklists By Area Failure',
  props<{ error: any }>()
);

export const search = createAction(
  '[Picklists] Search',
  props<{ query: string}>()
);

export const searchSuccess = createAction(
  '[Picklists] Search Success',
  props<{ picklists: IPicklist[], total: number}>()
);

export const searchFailure = createAction(
  '[Picklists] Search Failure',
  props<{ error: any }>()
);

export const incrementPage = createAction(
  '[Picklists] Increment Pagination',
  props<{ currentPage: any }>()
);

export const resetPage = createAction(
  '[Picklists] Reset Pagination'
);

export const resetPicklists = createAction(
  '[Picklists] Reset Picklists'
);

export const incrementPageSuccess = createAction(
  '[Picklists] Increment Pagination Success',
  props<{ currentPage: any }>()
);

export const decrementPage = createAction(
  '[Picklists] Decrement Pagination'
);

export const setBarcodeType = createAction(
  '[Picklists] Set Barcodes',
  props<{ data: any }>()
);

export const loadBarcodeType = createAction(
  '[Picklists] Load Barcodes',
  props<{ data: any }>()
);

export const setFilterType = createAction(
  '[Picklists] Set Filter Type',
  props<{ filterType: string, filterID: number }>()
);

export const setSelected = createAction(
  '[Picklists] Set Selected',
  props<{ selected: any }>()
);

export const setSort = createAction(
  '[Picklists] Set Sort',
  props<{ sort: string, direction: string, query: string }>()
);

export const resetPicklist = createAction(
  '[Picklists] Reset Picklist'
);

export const resetFilter = createAction(
  '[Picklists] Reset Filter'
)

export const setDeselected = createAction(
  '[Picklists] Set Deselected'
);

export const deletePicklists = createAction(
  '[Picklists] Delete Picklists',
  props<any>()
);

export const deletePicklistsSuccess = createAction(
  '[Picklists] Delete Picklists Success',
  props<any>()
);

export const deletePicklistsFailure = createAction(
  '[Picklists] Delete Picklists Failure',
  props<{ error: any }>()
);

export const deletePicklist = createAction(
  '[Picklists] Delete Picklist',
  props<{pickListID: number }>()
);

export const deletePicklistSuccess = createAction(
  '[Picklists] Delete Picklist Success',
  props<any>()
);

export const deletePicklistFailure = createAction(
  '[Picklists] Delete Picklist Failure',
  props<{ error: any }>()
);

export const createBarcode = createAction(
  '[Picklists] Create Barcode',
  props<{barcodeData: string, pickListID: number }>()
);

export const createBarcodeSuccess = createAction(
  '[Picklists] Create Barcode Success',
  props<any>()
);

export const createBarcodeFailure = createAction(
  '[Picklists] Create Barcode Failure',
  props<{ error: any }>()
);

export const setBarcodes = createAction(
  '[Picklists] Set Barcode',
  props<{barcodes: IBarcode[] }>()
);

export const setSelectedBarcode = createAction(
  '[Picklists] Set Selected Barcode',
  props<{ index: number }>()
)

export const deleteBarcode = createAction(
  '[Picklists] Delete Barcode',
  props<{barcodeID: number }>()
);

export const deleteBarcodeSuccess = createAction(
  '[Picklists] Delete Barcode Success',
  props<any>()
);

export const deleteBarcodeFailure = createAction(
  '[Picklists] Delete Barcode Failure',
  props<{ error: any }>()
);

export const exportPicklists = createAction(
  '[Picklists] Export Picklists'
);

export const sortByCategory = createAction(
  '[Picklists] Sort By Category Picklists',
  props<{ active: string, direction:string, category: number }>()
);

export const sortByCategorySuccess = createAction(
  '[Picklists] Sort By Category Picklists Success',
  props<any>()
);

export const sortByCategoryFailure = createAction(
  '[Picklists] Sort By Category Picklists Failure',
  props<{ error: any }>()
);

export const setIsLoading = createAction(
  '[Picklists] Set Is Loading',
  props<{ isLoading: boolean }>()
);

